/** @module csi/action/_SortOrderMixin */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/comm",
	"csi/types",
	"csi/xml"
], function(declare,_,comm,types,xml) {

	return declare(null, {
		/**
		 * Add request to get next node when inserting new node(s) before result representing action to get more results
		 * @param {DOMNode} refNodeNext
		 * @param {Request[]} requests
		 */
		_addSortOrderRequest: function(refNodeNext, requests) {
			var qrNext = refNodeNext && this.widget.getQueryResultByDomNode(refNodeNext);
			var urlNext = qrNext && qrNext.urlResultForAction;
			if (urlNext && qrNext.level.typeSortAttribute) {
				if (!this.m_cache.getNode(urlNext)) {
					requests.push(comm.getNodeRequest(urlNext));
				}
			}
		},
		
		/**
		 * Return sort order value for given node
		 * @param {string} url
		 * @param {string} idAttr
		 * @return {number}
		 */
		_getSortOrderValue: function(url, idAttr) {
			var node = this.m_cache.getNode(url);
			return node ? node[idAttr] : null;
		},
		
		/**
		 * Write operations to update sort order for given urls being inserted between refNodePrev and refNodeNext
		 * @param {string[]} urls - urls needing new sort values
		 * @param {string} idAttr - sort attribute id
		 * @param {string} [urlPrevious] - url preceding inserted nodes
		 * @param {string} [urlNext] - url following inserted nodes
		 * @param {string[]} [resultUrls] - list of urls in store containing both urlPrevious and urlNext
		 * @return {string} returns last url changed with the assumption that if called again that would
		 * be the new value of urlPrevious (with urlNext staying the same)
		 */
		_writeSortOrderValues: function(urls, idAttr, urlPrevious, urlNext, resultUrls) {
			var w = this.m_writer;
			var value1 = this._getSortOrderValue(urlPrevious, idAttr);
			var value2 = this._getSortOrderValue(urlNext, idAttr);
			var nPrevious = urlPrevious ? _.indexOf(resultUrls, urlPrevious) : -1;
			var duplicateUrls = [];
			
			// if value1 and value2 match, then expand urls whose sort order needs to be updated to all that have matching values
			while (urlPrevious && (value1 === value2)) {
				duplicateUrls.unshift(urlPrevious);
				urlPrevious = resultUrls[--nPrevious];
				value1 = this._getSortOrderValue(urlPrevious, idAttr);
			}

			var allUrls = duplicateUrls.concat(urls);
			
			_.each(allUrls, function(url) {
				value1 = types.getIntermediateSortValue(value1, value2);
				w.changeNode(url).changeAttribute(idAttr, xml.ATTR_DOUBLE, value1);
			});
			
			return allUrls.last();
		}
	});
});
